$b.on('click', '.favorite-selector', function(e){
  e.preventDefault();
  var $el = $(this);
  $.ajax({
    method: 'post',
    url: "/wp-admin/admin-ajax.php",
    data: {
    'action': 'rd_update_favorite_tracks',
    'tid': $el.data('tid')
    },
    success: function(data){
      var data = JSON.parse(data);
      if (data.errors) {
        alert('Sorry, there was an error updating your favorites.')
      } else {
        $el.toggleClass(site.ac);
        window.userFavs = data.success;
        let favs = data.success.split(',');
        if( favs.length ){
          // have favorites, hide all, then show
          $('#premium-picks .track').addClass(site.hc);
          favs.forEach(id => {
            $('#track-'+id).removeClass(site.hc);
          });
        } else {
          // no favorites, show all
          $('.track').removeClass(site.hc);
        }
      }
    }
  });
});

function updateSectionVisibility(showAll = false){
  const $sections = $('#premium-picks, #somo-bombs, #rockets');
  if (showAll) {
    $sections.show();
    $('#page-nav li').show();
    return;
  }
  $sections.each(function(){
    let $navItem = $(`#page-nav [href="#${$(this).attr('id')}"]`).closest('li');
    if ($(this).find('.track').length === $(this).find('.track.hidden').length) {
      $(this).hide();
      $navItem.hide();
    } else {
      $(this).show();
      $navItem.show();
    }
  });
}

$('#dashboard-view-option .option').on('click', function(e){
  e.preventDefault();
  var $btnText = $(this).closest('.dropdown').find('.btn .text');
  var $tracks = $('.track'); 
  $tracks.addClass(site.hc).removeClass('single-shown');
  $(this).closest('.dropdown').removeClass(site.ac);
  // show a single track
  if ($(this).hasClass('single-track-filter')) {
    $btnText.text($(this).text());
    $(`[data-tid="${$(this).data('tid')}"]`).removeClass(site.hc).addClass('single-shown');
    updateSectionVisibility();
    return;
  }
  // show all or favorites and save the setting for next time
  var setting = $(this).data('setting');
  if( setting === 'all' ){
    $tracks.removeClass(site.hc);
    $btnText.text('All Tracks');
    updateSectionVisibility(true);
  } else {
    var favs = window.userFavs.split(',');
    $btnText.text('Favorite Tracks');
    if( favs.length ){
      $tracks.addClass(site.hc);
      favs.forEach(id => {
        $(`[data-tid="${id}"]`).removeClass(site.hc);
      });
    }
    updateSectionVisibility();
  }
  

  $.ajax({
    method: 'post',
    url: "/wp-admin/admin-ajax.php",
    data: {
    'action': 'rd_update_dashboard_view',
    'setting': setting
    },
    success: function(data){
      var data = JSON.parse(data);
      if (data.errors) {
        alert('Sorry, there was an error updating your setting.')
      }
    }
  });
});

$b.on('click', '.print-trigger', function(e){
  e.preventDefault(); 
  var maxWidth = $(window).width() * .8;
  window.open($(this).attr('href'), 'printWindow', 'height='+$(window).height()+', width='+maxWidth+', top=0, left=' + ($(window).width() - maxWidth) /2 + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
});
